import { render, staticRenderFns } from "./TemplateBubble.vue?vue&type=template&id=16ac8844"
import script from "./TemplateBubble.vue?vue&type=script&lang=js"
export * from "./TemplateBubble.vue?vue&type=script&lang=js"
import style0 from "./TemplateBubble.vue?vue&type=style&index=0&id=16ac8844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports